import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { useRef, createElement } from 'react';
import { Plugin, Getter } from '@devexpress/dx-react-core';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { isEmptyObject } from './filtering/helpers.js';
var _excluded = ["filters", "sorting", "grouping"],
    _excluded2 = ["columnName"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var getStateFromLocalStorage = function getStateFromLocalStorage(key) {
  var filterObj;

  try {
    var filterFromStorage = window.localStorage.getItem(key);

    if (filterFromStorage) {
      filterObj = JSON.parse(filterFromStorage);
    }
  } catch (error) {
    console.log('localstorage get error: ', error);
  }

  return filterObj;
};

var setStateToLocalStorage = function setStateToLocalStorage(key, filterObj) {
  if (filterObj && isEmptyObject(filterObj)) {
    window.localStorage.removeItem(key);
  } else {
    var filters = filterObj.filters,
        sorting = filterObj.sorting,
        grouping = filterObj.grouping;

    var _ref = getStateFromLocalStorage(key) || {},
        filterFromStorage = _ref.filters,
        sortingFromStorage = _ref.sorting,
        groupingFromStorage = _ref.grouping,
        rest = _objectWithoutProperties(_ref, _excluded);

    var objToSave = {
      filters: filters !== null && filters !== void 0 ? filters : filterFromStorage,
      sorting: sorting !== null && sorting !== void 0 ? sorting : sortingFromStorage,
      grouping: grouping !== null && grouping !== void 0 ? grouping : groupingFromStorage
    };
    Object.assign(objToSave, rest);

    try {
      window.localStorage.setItem(key, JSON.stringify(objToSave));
    } catch (error) {
      console.log('localstorage set error: ', error);
    }
  }
};

var processGridState = function processGridState(storageKey, filterObj, isFirstRender, changeAction) {
  var filters = filterObj.filters,
      sorting = filterObj.sorting,
      grouping = filterObj.grouping;

  if (storageKey) {
    if (isFirstRender.current) {
      // first render,get state from local storage, if there is storage key
      var filterFromStorage = getStateFromLocalStorage(storageKey); // call from filters and if filter exists in storage, we set it back to grid via changeColumnFilter

      if (filterObj !== null && filterObj !== void 0 && filterObj.filters && filterFromStorage !== null && filterFromStorage !== void 0 && filterFromStorage.filters) {
        if (filterFromStorage.filters !== filters) {
          filters = filterFromStorage.filters; // trigger the action.

          changeAction && filterFromStorage.filters.forEach(function (filter) {
            var columnName = filter.columnName,
                rest = _objectWithoutProperties(filter, _excluded2);

            changeAction({
              columnName: columnName,
              config: _objectSpread({}, rest)
            });
          });
        }
      } // call from sorting and if sorting exists in storage, we set it back to grid via changeColumnSorting


      if (filterObj !== null && filterObj !== void 0 && filterObj.sorting && filterFromStorage !== null && filterFromStorage !== void 0 && filterFromStorage.sorting) {
        if (filterFromStorage.sorting !== sorting) {
          sorting = filterFromStorage.sorting; // trigger the action.

          changeAction && filterFromStorage.sorting.forEach(function (sort) {
            changeAction(sort);
          });
        }
      } // call from grouping and if grouping exists in storage, we set it back to grid via changeColumnGrouping


      if (filterObj !== null && filterObj !== void 0 && filterObj.grouping && filterFromStorage !== null && filterFromStorage !== void 0 && filterFromStorage.grouping) {
        if (filterFromStorage.grouping !== grouping) {
          grouping = filterFromStorage.grouping; // trigger the action.

          changeAction && filterFromStorage.grouping.forEach(function (item) {
            changeAction(item);
          });
        }
      }

      isFirstRender.current = false;
    } else {
      setStateToLocalStorage(storageKey, filterObj);
    }
  }

  return {
    filters: filters,
    sorting: sorting,
    grouping: grouping
  };
};

var GridStateStoringPlugin = function GridStateStoringPlugin(_ref2) {
  var storageKey = _ref2.storageKey;
  var isFirstRenderFilters = useRef(true);
  var isFirstRenderSorting = useRef(true);
  var isFirstRenderGrouping = useRef(true); // We adds a prefix, so that, we can clear it when needed. if someone used the same, thats bad luck!

  var prefixedKey = "AR_GRID~".concat(storageKey);
  return /*#__PURE__*/createElement(Plugin, {
    name: "gridStateStoring"
  }, /*#__PURE__*/createElement(Getter, {
    name: "filters",
    computed: function computed(_ref3, _ref4) {
      var filters = _ref3.filters;
      var changeColumnFilter = _ref4.changeColumnFilter;

      var _processGridState = processGridState(prefixedKey, {
        filters: filters
      }, isFirstRenderFilters, changeColumnFilter),
          updatedFilter = _processGridState.filters;

      return updatedFilter ? updatedFilter : [];
    }
  }), /*#__PURE__*/createElement(Getter, {
    name: "sorting",
    computed: function computed(_ref5, _ref6) {
      var sorting = _ref5.sorting;
      var changeColumnSorting = _ref6.changeColumnSorting;

      var _processGridState2 = processGridState(prefixedKey, {
        sorting: sorting
      }, isFirstRenderSorting, changeColumnSorting),
          updatedSort = _processGridState2.sorting;

      return updatedSort ? updatedSort : [];
    }
  }), /*#__PURE__*/createElement(Getter, {
    name: "grouping",
    computed: function computed(_ref7, _ref8) {
      var grouping = _ref7.grouping;
      var changeColumnGrouping = _ref8.changeColumnGrouping;

      var _processGridState3 = processGridState(prefixedKey, {
        grouping: grouping
      }, isFirstRenderGrouping, changeColumnGrouping),
          updatedGrouping = _processGridState3.grouping;

      return updatedGrouping ? updatedGrouping : [];
    }
  }));
};

export { GridStateStoringPlugin, getStateFromLocalStorage, processGridState, setStateToLocalStorage };